<template>
  <div v-if="loading_page === true">
    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </v-sheet>
  </div>
  <div v-else>
    <v-row>
      <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
        <div class="title_page ma-3">
          <h4 class="breadcrumb_title_page">สินค้าขายดีของแต่ละสาขา</h4>
          <v-breadcrumbs :items="sub_menu">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12 pt-0">
        <v-card elevation="4" style="border-radius: 15px">
          <v-card-text>
            <div class="pa-4">
              <v-form ref="#">
                <v-row>
                  <!-- ค้นหาล็อต -->
                  <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <div class="d-flex">
                      <div class="title_form_main">
                        <div class="logo_timeline">
                          <img src="@/assets/arin_assets/box.png" />
                        </div>
                      </div>
                      <div class="header-content py-1 pl-5 pr-5 text-center">
                        <div class="content-font">ดูรายการขายดีของสาขา</div>
                      </div>
                    </div>
                  </v-col>
                  <v-col xs="12" sm="12" md="11" lg="11" xl="11" cols="12">
                    <v-form-group>
                      <label class="label_form_text">
                        ชื่อสาขา <span class="required--text">*</span>
                      </label>
                      <v-autocomplete class="input-radius" v-model="branchId"  :items="branchList"
                        item-value="id" item-text="owner_name" placeholder="กรุณาเลือกชื่อสาขา" single-line solo
                        ref="branchList" :search-input.sync="search" outlined dense :filter="filterBranch">
                        <template slot="selection" slot-scope="{ item }">
                          {{ item.owner_name }}
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <v-list-tile-content>
                            <p class="fullName">{{ item.owner_name }}</p>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </v-form-group>

                  </v-col>
                  <v-col class="mt-2" xs="12" sm="12" md="1" lg="1" xl="1" cols="12">
                    <div @click="showProductAll()" class="title_page ma-3" style="justify-content: center">
                      <v-btn type="button" class="btn_add_data" elevation="4" large>ค้นหา</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="mb-10">
        <Transition name="slide-fade">
          <v-card v-if="show" elevation="4" style="border-radius: 15px">
            <v-card-text>
              <div class="pa-4">
                <v-form ref="#">
                  <v-row>
                    <!-- ค้นหาล็อต -->
                    <!-- <v-col cols="12">
                                        <div class="d-flex">
                                            <div class="text-center">
                                                <div class="content-header-title">รายการยอดขายแต่ละสาขา</div>
                                            </div>
                                        </div>
                                    </v-col> -->

                    <!-- <v-row class="border-color-milk">
                                        <v-col  xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="px-5">
                                            <div class="d-flex">รหัสสินค้า : {{data_list.lot_no}}</div>
                                        </v-col>
                                        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="px-5">
                                            <div class="d-flex">ชื่อสินค้า : {{data_list.product_name}}</div>
                                        </v-col>
                                        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="px-5 pt-1 pb-4">
                                            <div class="d-flex">ชื่อทางการแพทย์ : {{data_list.date_expired}}</div>
                                        </v-col>
                                        <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="px-5 pt-1 pb-4">
                                            <div class="d-flex">ประเภทสินค้า : {{data_list.supplier_name != null ? data_list.supplier_name : '-'}}</div>
                                        </v-col>
                                    </v-row> -->

                    <v-col cols="12" class="mt-5">
                      <div class="d-flex mb-8">
                        <div class="text-center">
                          <div class="content-header-title">
                            รายการยอดขายแต่ละสาขา
                          </div>
                        </div>
                        <v-row class="mb-4" align="center">
                          <v-spacer></v-spacer>
                          <v-btn color="success" @click="exportToExcel">
                            <v-icon left>mdi-microsoft-excel</v-icon>
                            Excel
                          </v-btn>
                        </v-row>
                      </div>
                      <v-row class="align-center mb-2">
                        <v-col xs="12" sm="6" md="3" lg="3" xl="3" class="mt-5">
                          <v-text-field v-model="searchDateStart" label="วันที่เริ่มต้น" type="date"
                            class="input-radius" color="#D6BFAF" outlined dense @change="checkDate"></v-text-field>
                        </v-col>

                        <v-col xs="12" sm="6" md="3" lg="3" xl="3" class="mt-5">
                          <v-text-field v-model="searchDateEnd" label="วันที่สิ้นสุด" type="date" class="input-radius"
                            color="#D6BFAF" outlined dense></v-text-field>
                        </v-col>
                        <v-col xs="0" sm="0" md="2" lg="2" xl="2"> </v-col>
                        <v-col xs="12" sm="12" md="4" lg="4" xl="4">
                          <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify"
                            hide-details="auto" v-model="searchTable" placeholder="ค้นหา..." single-line outlined
                            dense></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-row class="border-color-milk">
                      <v-col cols="12">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">ลำดับ</th>
                                <th class="text-left">รหัสสินค้า</th>
                                <th class="text-left">ชื่อสินค้า</th>
                                <th class="text-left">ชื่อทางแพทย์</th>
                                <th class="text-left">ยอดขาย</th>
                                <th class="text-left">หน่วยนับ</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(productall, index) in show_data_list" :key="index">
                                <td>{{ (index + 1) + ((page - 1) * 10) }}</td>
                                <td>{{ productall.product_code }}</td>
                                <td>{{ productall.name }}</td>
                                <td>
                                  {{
                                    productall.name_sci
                                      ? productall.name_sci
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    productall.total_unit
                                      ? productall.total_unit
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    productall.unit_name
                                      ? productall.unit_name
                                      : "-"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-col>
                      <v-col cols="12">
                        <div class="text-center" @click="
                          searchBestSell()
                          ">
                          <v-pagination color="#d0b19b" v-model="page" :total-visible="7"
                            :length="page_all"></v-pagination>
                        </div>
                      </v-col>
                    </v-row>
                  </v-row>
                </v-form>
              </div>
            </v-card-text>
          </v-card>
        </Transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Search_stock",
  data() {
    return {
      show: false,
      branchId: null,
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "คลังสินค้า",
          disabled: false,
        },
        {
          text: "คลัง",
          disabled: false,
        },
        {
          text: "สินค้าขายดีของแต่ละสาขา",
          disabled: false,
          href: "#",
        },
      ],
      branchList: [],
      data_list: [],
      show_data_list: [],
      search: "",
      searchTable: "",
      searchDateStart: "",
      searchDateEnd: "",
      no: 1,
      page: 1,
      size: 10,
      page_all: 1,
    };
  },
  methods: {
    displayText(item) {
      return `${item.product_name} (${item.lot_no}) - Exp. ${item.date_expired}`;
    },
    getBranchAll() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.get("/warehouse/branchall", config).then((res) => {
        if (res.data.successful === true) {
          this.branchList = res.data.branchtList;
          this.loading_page = false;
        }
      });
    },
    filterBranch(item, queryText) {
      const text = item.owner_name.toString().toLowerCase();
      const q = (queryText || '').toLowerCase();
      return text.includes(q);
    },
    showProductAll() {
      const data = {
        branchId: this.branchId,
        page: this.page,
        size: this.size,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.post("/warehouse/goodsalesproductall", data, config).then(
        (res) => {
          if (res.data.successful === true) {
            this.data_list = res.data.goodSalesList.data;
            this.page_all = res.data.goodSalesList.totalPages;
            this.show_data_list = this.data_list;
            this.loading_page = false;
            this.show = true;
          }
        }
      );
    },
    searchBestSell() {
      const data = {
        branchId: this.branchId,
        searchValue: this.searchTable,
        searchDateStart: this.searchDateStart,
        searchDateEnd: this.searchDateEnd,
        page: this.page,
        size: this.size,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.post("/warehouse/goodsalesproductall", data, config).then(
        (res) => {
          if (res.data.successful === true) {
            this.data_list = res.data.goodSalesList.data;
            this.page_all = res.data.goodSalesList.totalPages;
            this.show_data_list = this.data_list;
            this.loading_page = false;
            this.show = true;
          }
        }
      );
    },
    checkDate() {
      if (this.searchDateStart == '' || this.searchTable == '' || this.searchDateEnd == '') {
        this.searchBestSell();
      }
    },
    async exportToExcel() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };

      // คำนวนขนาดทั้งหมด = จำนวนหน้า × ขนาดต่อหน้า
      const totalPages = this.page_all || 1;
      const pageSize = this.size;
      const allSize = totalPages * pageSize;

      // ส่ง request ทีเดียว
      const payload = {
        branchId: this.branchId,
        searchValue: this.searchTable,
        searchDateStart: this.searchDateStart,
        searchDateEnd: this.searchDateEnd,
        page: 1,
        size: allSize,    // ขอทั้งหมดในครั้งเดียว
      };

      try {
        const res = await HTTP_ARIN.post("/warehouse/goodsalesproductall", payload, config);
        if (!res.data.successful) {
          throw new Error("Fetch failed");
        }

        // ดึง data มาทั้งหมด
        const allItems = res.data.goodSalesList.data;

        // แปลงเป็น rawData
        const rawData = allItems.map((item, idx) => ({
          'ลำดับ': idx + 1,
          'รหัสสินค้า': item.product_code,
          'ชื่อสินค้า': item.name,
          'ชื่อทางแพทย์': item.name_sci || "-",
          'ยอดขาย': item.total_unit != null ? item.total_unit : "-",
          'หน่วยนับ': item.unit_name || "-",
        }));




        // สร้าง sheet + workbook + ดาวน์โหลด
        const ws = XLSX.utils.json_to_sheet(rawData);
        // 2) ตั้งความกว้างของคอลัมน์ (!cols)
        ws['!cols'] = [
          { wch: 6 }, // ลำดับ (6 ตัวอักษร)
          { wch: 15 }, // รหัสสินค้า
          { wch: 30 }, // ชื่อสินค้า
          { wch: 25 }, // ชื่อทางแพทย์
          { wch: 10 }, // ยอดขาย
          { wch: 10 }, // หน่วยนับ
        ];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "ยอดขายสาขา");
        let filename;
        if (this.searchDateStart && this.searchDateEnd) {
          filename = `best_selling_${this.searchDateStart}_to_${this.searchDateEnd}.xlsx`;
        } else {
          filename = `best_selling_All.xlsx`;
        }


        XLSX.writeFile(wb, filename);
      } catch (err) {
        console.error("Export failed:", err);
        this.alert_message_error = "ไม่สามารถส่งออกข้อมูลได้";
        this.alert_error = true;
        setTimeout(() => (this.alert_error = false), 5000);
      }
    },





  },
  mounted() {
    this.getBranchAll();
  },
  watch: {
    searchTable() {
      this.searchBestSell();
    },
    searchDateStart() {
      if (
        !(!this.searchDateStart && this.searchDateStart == "") &&
        !(!this.searchDateEnd && this.searchDateEnd == "")
      ) {
        this.searchBestSell();
      }
    },
    searchDateEnd() {
      if (
        !(!this.searchDateStart && this.searchDateStart == "") &&
        !(!this.searchDateEnd && this.searchDateEnd == "")
      ) {
        this.searchBestSell();
      }
    },
  },
};
</script>

<style>
.btn_add_data {
  font-size: 16px;
  color: rgb(255, 255, 255) !important;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  width: 100%;
}

.border-color-milk {
  border: 1px solid #d6bfaf;
  border-radius: 10px;
  margin: 0;
}

.content-header-title {
  color: #616a6b;
  font-weight: 1000;
  font-size: 22px;
}

.title_form_main {
  background: #d6bfaf;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.logo_timeline {
  padding: 6px;
}

.logo_timeline>img {
  max-width: 25px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.content-font {
  color: #616a6b;
  font-weight: 500;
  font-size: 16px;
}

label.label_form_text {
  font-size: 16px !important;
  color: #616a6b !important;
}

.input-radius {
  border-radius: 10px;
}

.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

@media only screen and (max-width: 600px) {

  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }
}
</style>
